require("D:\\codebox\\devnest\\investup\\investup-web\\node_modules\\bootstrap-sass\\assets\\javascripts\\bootstrap\\transition");


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass-loader/bootstrap-sass-scripts.loader.js!./assets/js/bootstrap-sass-config.js
// module id = 97
// module chunks = 0